import { render, staticRenderFns } from "./EstimatesOldPanelsActivity.vue?vue&type=template&id=d4600e22&"
import script from "./EstimatesOldPanelsActivity.vue?vue&type=script&lang=js&"
export * from "./EstimatesOldPanelsActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports